import React, {Fragment} from 'react';
import styled from 'styled-components';
import { compose} from "redux";
import { connect } from "react-redux";
import _ from 'lodash';
import numberFormatter from 'utils/numberFormatter';
import {Grid} from '@material-ui/core';
import {resetTestData} from 'store/state/calculators';
import { ResultErrorContainer, BlueResult, CenterAlignedValue, WhiteBackground, BigText, CenterAlignedLabel, FancyDividerBlack, FancyDividerGray, PrimaryDataWrapper, AddRow, CenteredVerticalSpace, CenterAlignedGrid, LeftAlignedGrid, RightAlignedGrid, AdditionalInformationWrapper, FlexContainer, } from '../styles'

const Disclosure = styled.div`&& {
  font-family: Work Sans;    
  font-style: normal;
  font-weight: 400;
  line-height: 23px;
  letter-spacing: 0em;  
  font-size:13px !important;
}
`

  const PrimaryData = ({value, label}) => {
    return (
      <CenteredVerticalSpace>
        <CenterAlignedValue>{value}</CenterAlignedValue>
        <CenterAlignedLabel>{label}</CenterAlignedLabel>
      </CenteredVerticalSpace>
    )
  }
  
  class AnalysisResult extends React.Component {

    componentDidMount(){
      if(this.props.loanProceeds != {}) {
        this.props.resetTestData();
      }
    }
    
    formatCalculatedValues = (type, value, column) => {
      if(!value) return "--";
      if(type === "DSCR_CHECK") 
        return column === "DSCR" ? `${numberFormatter.formatDecimal(value,2)}x` : numberFormatter.formatRate(value,0);      
      else
        return numberFormatter.formatMoney(value,2);
    }
    formatCalculatedValuesTypes = (type) => {
      switch (type) {
        case "PROCEEDS":
          return "Proceeds";
        case "PMT":
          return "PMT";
        case "ANNUAL_DEBT_SERVICE":
          return "Annual Debt Service";
        case "DSCR_CHECK":
          return "Constraints";
        default:
          return "N/A";
      }
    }
    
    render() {  
      const {loanProceeds} = this.props;

    if(_.isEmpty(loanProceeds))
      return null;
    
    if(!loanProceeds.success)
      return (<ResultErrorContainer><p>We were not able to calculate your Loan Proceeds.</p><p>Please check your inputs.</p></ResultErrorContainer>);
    else
    return (
      <Fragment>
        <BlueResult>
          <PrimaryDataWrapper>
            <WhiteBackground>
              <BigText>{numberFormatter.formatMoney(loanProceeds.maxProceeds,0,"--")}</BigText>
              <CenterAlignedLabel>MAX PROCEEDS</CenterAlignedLabel> 
            </WhiteBackground>
            <AddRow><PrimaryData value={numberFormatter.formatRate(loanProceeds.allInRate,3,"--")} label='ALL-IN RATE'/></AddRow>
            <AddRow><PrimaryData value={numberFormatter.formatMoney(loanProceeds.monthlyPayment,2,"--")} label='MONTHLY PAYMENT'/></AddRow>
            <AddRow><PrimaryData value={numberFormatter.formatMoney(loanProceeds.assetValue,2,"--")} label='ASSET VALUE'/></AddRow>
          </PrimaryDataWrapper>
        </BlueResult>
          
          <AdditionalInformationWrapper> 
            <FlexContainer>
            <Grid container justify="space-between" direction="row">
              <CenterAlignedGrid item xs={3}></CenterAlignedGrid>
              <CenterAlignedGrid item xs={3}>DSCR</CenterAlignedGrid>
              <CenterAlignedGrid item xs={3}>LTV</CenterAlignedGrid>
              <CenterAlignedGrid item xs={3}>Debt Yield</CenterAlignedGrid>
              <Grid item xs={12}><FancyDividerBlack/></Grid>
              {loanProceeds.loanProceedsCalculatedValues.map(row => {
                return (<Fragment>
                          <LeftAlignedGrid item xs={3}>{this.formatCalculatedValuesTypes(row.type)}</LeftAlignedGrid>
                          <RightAlignedGrid item xs={3}>{this.formatCalculatedValues(row.type, row.maxProceedsDSCR, "DSCR")}</RightAlignedGrid>
                          <RightAlignedGrid item xs={3}>{this.formatCalculatedValues(row.type, row.maxLTV, "LTV")}</RightAlignedGrid>
                          <RightAlignedGrid item xs={3}>{this.formatCalculatedValues(row.type, row.maxDebtYield,"DebtYield")}</RightAlignedGrid>
                          <Grid item xs={12}><FancyDividerGray/></Grid>
                        </Fragment>);
                    })}
            </Grid>
            </FlexContainer>
          </AdditionalInformationWrapper>
          <Disclosure>Calculations are for informational purposes and subject to change with market conditions.</Disclosure>
      </Fragment>
    )};
}
function mapStateToProps({testHarness}) {
  return {
    loanProceeds: testHarness.loanProceeds && testHarness.loanProceeds.calculator ? testHarness.loanProceeds.calculator : null,
  }
}
export default compose(  
  connect(
    mapStateToProps,
    {resetTestData}
  )
)(AnalysisResult);